import DocumentEditor from '@root/components/DocumentView/components/CommonEditor';
import DocumentPreview from '@root/components/DocumentView/components/CommonPreview';

import Icon from './BlogPost.icon';
import Page from './BlogPost.page';

const file = {
  DocumentEditor,
  DocumentPreview,
  Icon,
  CustomPage: Page,
};

export default file;
